export default "__VITE_ASSET__cJinY8z6HkMOTftdW$lZyA__"